import { VOICE_NAMES, VOICE_LABELS } from '../utils/musicTheory'

export default function VoiceTabs({
  activeVoice,
  onSelect,
  disabledVoices = [],
  disabledTitle = '이 성부는 지금은 선택할 수 없습니다.',
}) {
  return (
    <div className="voice-tabs">
      {VOICE_NAMES.map(v => (
        <button
          key={v}
          type="button"
          className={`vtab ${activeVoice === v ? 'active' : ''}`}
          onClick={() => onSelect(v)}
          disabled={disabledVoices.includes(v)}
          title={disabledVoices.includes(v) ? disabledTitle : undefined}
        >
          {VOICE_LABELS[v]}
        </button>
      ))}
    </div>
  )
}
